import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import LoadingContent from '../../components/loadingContent/LoadingContent';

const REDIRECTION_DELAY_MS = 1000;

interface Props {
  state?: { from?: string };
}

export default function SignInRedirectPage({ state }: Props): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation('signInRedirectPage');
  const from = state?.from;

  useEffect(() => {
    setTimeout(() => {
      navigate(from ?? '/');
    }, REDIRECTION_DELAY_MS);
  }, [navigate, from]);

  return (
    <LoadingContent
      message={t('message') ?? ''}
      title={t('title') ?? ''}
    />
  );
}
